var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeartFill = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M10.052 3c-.624-.818-1.278-1.584-2.15-2.142l-.12-.074C6.209-.17 4.266-.315 2.663.664c-.64.39-1.18.937-1.57 1.577-.98 1.606-.68 3.476.147 5.081.743 1.438 1.808 2.695 2.928 3.85 1.63 1.68 3.987 3.372 5.88 4.748 1.892-1.376 4.31-3.069 5.94-4.748 1.122-1.155 2.187-2.412 2.929-3.85.828-1.605 1.126-3.475.147-5.081-.389-.64-.93-1.188-1.57-1.577-1.603-.979-3.546-.835-5.12.12l-.119.074c-.872.558-1.579 1.324-2.202 2.142z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FFD4D4",
  mask: "url(#prefix__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(-2 -4)"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeartFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart-fill.e35a8e151e5f95acda70b5087c52bbc6.svg";